import Component from './route-component';
import Enhance from '../core/enhance'
import Route from './route';
import tools from '../libs/tools';
import CSSTransitionGroup from 'react-addons-css-transition-group'
import $event from '../decorators/$event';
import checkPath from './utils/checkPath';
import React from 'react'
import debug from 'debug';

let log = debug('router.router');
const cache = {};
let init = false;

/**
 *
 */
class Router extends Component {

    static type = 'url';

    static defaultProps = {
        name: tools.uuid()
    }


    views = null;

    /**
     *
     * @param url
     * @param state
     */
    static push(url, state = {}) {
        log('push', url, state);
        switch (Router.type) {
            case "url":
                window.appHistory.push(url, state)
                break;
            case "hash":
                window.appHistory.push('#' + url, state)
                break;
            case "state":
                state.url = url;
                window.appHistory.push(null, state);
                break;
        }

    }

    /**
     *
     * @param url
     * @param state
     */
    static replace(url, state = {}) {
        log('replace', url, state);
        window.appHistory.replace(url, state)
    }

    /**
     *
     * @param num
     */
    static pop(num) {
        log('pop', num);
        window.appHistory.go(num)
    }

    /**
     *
     * @param props
     * @param context
     */
    constructor(props, context) {
        super(props, context);
        if (!init) {
            this.isRoot = true;
            init = true
        }
        let ignore = [];
        $.each(this.props.forceIgnore, (k, v) => {
            ignore.push(checkPath(v));
        });
        this.ignore = ignore;
        cache[this.props.name] = 0
    }

    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        let location = this.location();
        let {force} = this.props;
        if (this.isRoot && force) {
            let forcepath = checkPath(force);
            let pathname = checkPath(location.pathname);
            if (forcepath !== pathname && location.state == null && this.ignore.indexOf(pathname) == -1) {
                Router.replace(forcepath);
                Router.push(pathname);
            }
        }
        this._findRoute();
        this.forceUpdate();
        // 路由变更通知事件
        //this._on('Router.listen', this.handlerRouterListen);
    }

    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    componentWillUnmount() {
        // 卸载事件
        //this._un('Router.listen', this.handlerRouterListen);
    }

    /**
     * 输入参数 nextProps 是即将被设置的属性，
     * 旧的属性还是可以通过 this.props 来获取。
     * 在这个回调函数里面，你可以根据属性的变化，
     * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
     * 并不会触发额外的 render() 调用
     */
    // componentWillReceiveProps(nextProps) {
    //     this._findRoute();
    // }

    /**
     *shouldComponentUpdate(object nextProps, object nextState): boolean
     * 当组件做出是否要更新DOM的决定的时候被调用。
     * 实现该函数，优化this.props和nextProps，以及this.state和nextState的比较，
     * 如果不需要React更新DOM，则返回false。
     */
    // shouldComponentUpdate(nextProps, nextState) {
    //     if (this.props.name !== nextProps.name) {
    //         delete cache[this.props.name];
    //         cache[nextProps.name] = 0;
    //     }
    // }

    /**
     * componentWillUpdate(object nextProps, object nextState)在更新发生之前被调用。
     * 你可以在这里调用this.setState()。
     */
    componentWillUpdate(nextProps, nextState) {
        this._findRoute();
    }


    /**
     *
     * @return {*}
     */
    render() {

        // console.log('render router');

        let transition = this._transition();
        if (this.props.transition) {
            let {timeout} = this.props;
            return (
                <CSSTransitionGroup
                    className="c-router"
                    transitionName={transition}
                    transitionEnter={!!transition}
                    transitionLeave={!!transition}
                    transitionEnterTimeout={timeout || 0}
                    transitionLeaveTimeout={timeout || 0}
                >
                    {[this.views]}
                </CSSTransitionGroup>
            );
        } else {
            return <div className="c-route">{this.views}</div>;
        }

    }

    /**
     *
     * @param data
     * @param type
     */
    @$event('Router.listen')
    handlerRouterListen = (data, type) => {
        log('Router.listen', data, type)
        let {name} = this.props;
        if (name) {
            if (type === "PUSH") {
                cache[name] = 1;
            } else if (type === 'POP') {
                cache[name] = -1;
            }
        }
        this.forceUpdate();
    }

    /**
     *
     * @private
     */
    _findRoute = () => {
        this.views = null;
        let {pathname, hash, search} = this.location();

        switch (Router.type) {
            case "hash":
                pathname = hash.substr(1);
                break;
            case "state":
                if (window.appHistory.location.state) {
                    pathname = window.appHistory.location.state.url;
                }
                else {
                    pathname = '';
                }
                break;
        }

        pathname = checkPath(pathname);
        let params = {}, defaultElem = null;
        if (search) {
            tools.parse_str(search.substring(1), params);
        }


        React.Children.forEach(this.props.children, (elem) => {
            if (!this.views && React.isValidElement(elem) && elem.type === Route) {
                if (!defaultElem)
                    defaultElem = elem;
                let path = checkPath(elem.props.path);
                if (pathname === path || path === true) {
                    this.views = React.cloneElement(elem, {key: path, path, pathname, hash, params});
                }
            }
        });

        //console.log(defaultElem);

        if (defaultElem && !this.views) {
            this.views = React.cloneElement(defaultElem, {
                key: defaultElem.props.path,
                path: checkPath(defaultElem.props.path),
                pathname,
                hash,
                params
            });
        }
        else if (!this.views) {
            this.views = <div key='empty' className='c-router-error'>页面未找到</div>;
        }

        // this.forceUpdate();
    }

    /**
     *
     * @returns {*}
     * @private
     */
    _transition() {
        let {name, transition} = this.props;
        if (transition) {
            switch (cache[name]) {
                case 1:
                    return transition[0];
                case -1:
                    return transition[1];
                default:
                    return "";
            }
        } else {
            return "";
        }

    }
}

Enhance(Router, {}, 'Router');
export default Router
